import useSharedFormFillingGinRichTextParseOptions from '@hellodarwin/app-features/lib/features/gin-steps/common-components/gin-step-item/form-filling/use-form-filling-gin-rich-text-parse-options';
import { GoogleDriveFile } from '@hellodarwin/core/lib/features/entities/google-drive-entities';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/app-hooks';
import { selectItemsById } from '../../../../../features/api/slices/gin-steps-slice';
import { copyFileToProgramFolder } from '../../../../../features/api/slices/google-drive-slice';
import { useNewClientApi } from '../../../../../features/api/use-client-api';

const useFormFillingGinRichTextParseOptions = (programId: string) => {
  const dispatch = useAppDispatch();
  const api = useNewClientApi();
  const itemsById = useAppSelector(selectItemsById);

  const copyFileToProgram = useCallback(
    async (fileId: string): Promise<GoogleDriveFile> => {
      return dispatch(
        copyFileToProgramFolder({
          api,
          programId,
          fileId,
          cancelIfAlreadyExists: true,
        }),
      ).unwrap();
    },
    [dispatch, api, programId],
  );

  return useSharedFormFillingGinRichTextParseOptions({
    itemsById: itemsById ?? undefined,
    copyFileToProgram,
  });
};

export default useFormFillingGinRichTextParseOptions;
